import { useMutation } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { CommonResType } from '@/types/commonApiType';

import { api } from './_http';

// 고객의 소리 저장
type SaveVoiceResType = CommonResType;

export const useSaveVoiceApi = () => {
	const url = '/v1/front/saveVoice';

	const mutationFn = async (data: FormData) => {
		const config = {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		};

		return api.post<SaveVoiceResType>(url, data, config);
	};

	return useMutation<AxiosResponse<SaveVoiceResType>, AxiosError, FormData>({
		mutationFn,
	});
};
